import { gql } from '@apollo/client';

export const GET_SORTING_LABOR_TEAM_LISTING = gql`
    query GetSortingLaborTeamListing(
        $hubId: Long!
        $filters: SortingLaborTeamFiltersInput
        $pageRequest: PageRequestTypeInput
    ) {
        getSortingLaborTeamListing(hubId: $hubId, filters: $filters, pageRequest: $pageRequest) {
            content {
                accountId
                name
                phone
                laborTeamName
                status
                role
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export const LABOR_TEAM_UNASSIGNED_FILTER = '__UNASSIGNED__';
export const BATCH_UPDATE_LIMIT = 200;

export interface SortingLaborTeamAccount {
    accountId: string;
    name: string;
    phone?: string | null;
    laborTeamName?: string | null;
    status: number;
    role: string;
}

export interface SortingLaborTeamListingResponse {
    getSortingLaborTeamListing: {
        content: SortingLaborTeamAccount[];
        page: number;
        size: number;
        totalElements: number;
        totalPages: number;
        hasNext: boolean;
        hasPrevious: boolean;
    };
}

export interface SortingLaborTeamFiltersInput {
    name?: string;
    phone?: string;
    laborTeamName?: string;
}
